import type { FC } from 'react';

import EntraSupportButton from './EntraSupportButton';
import type { SupportButtonProps } from './types';

const getSupportButton = (): FC<SupportButtonProps> => {
  const isEntra = import.meta.env?.VITE_AUTH_METHOD === 'entra';

  if (isEntra) {
    return EntraSupportButton;
  }

  return () => null;
};

const SupportButton = getSupportButton();
export default SupportButton;
